import { t } from './i18n';

export function formatActivationCountdown(expiresAt: string, nowMs: number): string {
  const total = Math.max(0, Math.ceil((new Date(expiresAt).getTime() - nowMs) / 1000));
  if (total <= 0) return t('已过期');
  const days = Math.floor(total / 86_400);
  const hours = Math.floor((total % 86_400) / 3_600);
  const minutes = Math.floor((total % 3_600) / 60);
  const seconds = total % 60;
  const clock = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return days > 0 ? t('{days}天 {clock}', { days, clock }) : clock;
}